import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuPanel from "./MenuPanel";
import AboutPanel from './AboutPanel';
import FooterPanel from './FooterPanel';
import CommunityImagePanel from "./CommunityImagePanel";
import CommunityPanel from "./CommunityPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class AboutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
      const { classes } = this.props;

      return (
          <div className={classes.branding}>
              <MenuPanel page={'about'}/>
              <AboutPanel/>
              <CommunityImagePanel/>
              <CommunityPanel/>
              <FooterPanel/>
          </div>
      );
  }
}

export default withStyles(useStyles)(AboutPage)
